import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getProList} from '../../../apis/user/getProList'

const PAGE_SIZE = 10

const useQueryProList = (currentPage?: number) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.user.getProList(currentPage),
        queryFn: async () => {
            const {data, pageInfo} = await getProList(PAGE_SIZE, currentPage)
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryProList
